// Hamburger

$(document).ready(function() {
    $('.hamburger_menu').click(function() {
      $(this).toggleClass('active');
      $('.enh_nav ul').slideToggle();
    });
    $(window).resize(function() {
        $('.hamburger_menu').removeClass('active');
        if ($(window).width() >= 767) {
            $('.enh_nav ul').css('display', 'inline-block');
        } else {
            $('.enh_nav ul').hide();
        }
    });
});

// Video Testimonials

$(document).ready(function() {
  $('.video_testimonial span').click(function() {
    $(this).hide();
    $(this).next('.video_overlay').hide();
    $(this).next().next('video')[0].play();
  });
  $('.video_testimonial video').on('click', function() {
    if (this.paused) {
      this.play();
      $(this).prev().prev('span').hide();
      $(this).prev('.video_overlay').hide();
    } else {
      this.pause();
      $(this).prev().prev('span').show();
      $(this).prev('.video_overlay').show();
    }
  });
});

// Countdown Timer

$(document).ready(function() {
    var $countdown = $('.enh_countdown');
    var countdownHours = parseInt($countdown.find('.countdown_hours').attr('data-value'), 10);
    var countdownMinutes = parseInt($countdown.find('.countdown_minutes').attr('data-value'), 10);
    var countdownSeconds = parseInt($countdown.find('.countdown_seconds').attr('data-value'), 10);
    var totalSeconds = (countdownHours * 3600) + (countdownMinutes * 60) + countdownSeconds;
    var interval;
    var storageKey = 'enh_countdown_time';

    function updateTimerDisplay(hours, minutes, seconds) {
        $countdown.find('.countdown_hours').text(hours.toString().padStart(2, '0'));
        $countdown.find('.countdown_minutes').text(minutes.toString().padStart(2, '0'));
        $countdown.find('.countdown_seconds').text(seconds.toString().padStart(2, '0'));
    }

    function saveTimeToLocalStorage(time) {
        localStorage.setItem(storageKey, time);
    }

    function startCountdown(remainingTime) {
        interval = setInterval(function() {
            if (remainingTime <= 0) {
                clearInterval(interval);
                localStorage.removeItem(storageKey);
                updateTimerDisplay(0, 0, 0);
            } else {
                remainingTime--;
                var hours = Math.floor(remainingTime / 3600);
                var minutes = Math.floor((remainingTime % 3600) / 60);
                var seconds = remainingTime % 60;
                updateTimerDisplay(hours, minutes, seconds);
                saveTimeToLocalStorage(remainingTime);
            }
        }, 1000);
    }

    var storedTime = parseInt(localStorage.getItem(storageKey), 10);
    var initialTime = isNaN(storedTime) || storedTime <= 0 ? totalSeconds : storedTime;

    var initialHours = Math.floor(initialTime / 3600);
    var initialMinutes = Math.floor((initialTime % 3600) / 60);
    var initialSeconds = initialTime % 60;

    updateTimerDisplay(initialHours, initialMinutes, initialSeconds);
    startCountdown(initialTime);
});

// FAQ

$(document).ready(function() {
    $('.faq_tab p').hide();
    $('.enh_faq .faq_tab:first-child p').show();
    $('.enh_faq .faq_tab:first-child').addClass('open');

    $('.faq_tab h3').click(function() {
        var $this = $(this);
        var $parentTab = $this.closest('.faq_tab');
        var $paragraph = $this.next('p');

        if ($paragraph.is(':visible')) {
            $parentTab.removeClass('open');
        } else {
            $parentTab.addClass('open');
        }

        $paragraph.slideToggle();
    });
});

// Sticky Gallery

$(document).ready(function () {
    const $stickyElement = $('.sticky_gallery');
    const $parentWrapper = $stickyElement.closest('.enh_wrapper');
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    let initialOffset;

    function calculateInitialOffset() {
        $stickyElement.css({
            position: 'relative',
            top: 'initial',
            width: '',
            left: '',
            padding: '',
        });
        initialOffset = $stickyElement.offset().top;
    }

    function handleScroll() {
        const scrollTop = $(window).scrollTop();
        const parentTop = $parentWrapper.offset().top;
        const parentBottom = parentTop + $parentWrapper.outerHeight();
        const stickyHeight = $stickyElement.outerHeight();
        const parentWidth = $parentWrapper.outerWidth();
        const stickyWidth = (parentWidth * 0.5) - 20;

        if (scrollTop >= initialOffset && scrollTop + stickyHeight < parentBottom) {
            $stickyElement.css({
                position: 'fixed',
                top: '10px',
                left: $parentWrapper.offset().left,
                width: stickyWidth,
                padding: '20px 0 50px 0',
            });
        } else if (scrollTop + stickyHeight >= parentBottom) {
            $stickyElement.css({
                position: 'absolute',
                top: parentBottom - stickyHeight - parentTop,
                width: stickyWidth,
                left: '0',
                padding: '20px 0 50px 0',
            });
        } else {
            $stickyElement.css({
                position: 'relative',
                top: 'initial',
                width: stickyWidth,
                left: '0',
                padding: '0',
            });
        }
    }

    function handleResize() {
        if (mediaQuery.matches) {
            calculateInitialOffset();
            $(window).on('scroll', handleScroll);
            handleScroll();
        } else {
            $(window).off('scroll', handleScroll);
            $stickyElement.css({
                position: '',
                top: '',
                width: '',
                left: '',
                padding: '',
            });
        }
    }

    $(window).on('resize', handleResize);
    handleResize();

    $(window).on('load', function () {
        calculateInitialOffset();
        handleScroll();
    });
});



// Image Gallery

$(document).ready(function() {
    $('.secondary_images img').on('click', function() {
        var newSrc = $(this).attr('src');
        var newAlt = $(this).attr('alt');
        
        $('.primary_image img').attr('src', newSrc);
        $('.primary_image img').attr('alt', newAlt);
    });

    var primaryImage = document.querySelector('.primary_image img');
    var startX = 0;
    var startY = 0;
    var endX = 0;
    var endY = 0;

    primaryImage.addEventListener('touchstart', function(event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
    });

    primaryImage.addEventListener('touchmove', function(event) {
        endX = event.touches[0].clientX;
        endY = event.touches[0].clientY;
        
        var deltaX = Math.abs(endX - startX);
        var deltaY = Math.abs(endY - startY);

        if (deltaX > deltaY) {
            event.preventDefault();
        }
    });

    primaryImage.addEventListener('touchend', function(event) {
        endX = event.changedTouches[0].clientX;
        endY = event.changedTouches[0].clientY;
        handleSwipe();
    });

    function handleSwipe() {
        var swipeDistanceX = endX - startX;
        var swipeDistanceY = endY - startY;
        
        if (Math.abs(swipeDistanceX) > Math.abs(swipeDistanceY)) {
            if (swipeDistanceX > 50) {
                changeImage('prev');
            } else if (swipeDistanceX < -50) {
                changeImage('next');
            }
        }
    }

    function changeImage(direction) {
        var currentSrc = $('.primary_image img').attr('src');
        var secondaryImages = $('.secondary_images img');
        var currentIndex = secondaryImages.index(secondaryImages.filter('[src="' + currentSrc + '"]'));
        
        var newIndex;
        if (direction === 'next') {
            newIndex = (currentIndex + 1) % secondaryImages.length;
        } else if (direction === 'prev') {
            newIndex = (currentIndex - 1 + secondaryImages.length) % secondaryImages.length;
        }
        
        var newSrc = secondaryImages.eq(newIndex).attr('src');
        var newAlt = secondaryImages.eq(newIndex).attr('alt');

        $('.primary_image img').attr('src', newSrc);
        $('.primary_image img').attr('alt', newAlt);
    }
});

// Reveal Slider

$(document).ready(function() {
    const $container = $('.image_reveal_container');
    const $sliderHandle = $('.slider_handle');
    const $imageRight = $('.image_right');

    function setInitialPosition() {
        const containerWidth = $container.width();
        const initialPosition = containerWidth / 2;

        $sliderHandle.css('left', `${initialPosition}px`);
        $imageRight.css('clip', `rect(0, ${initialPosition}px, auto, 0)`);
    }
    setInitialPosition();
  
    $(window).on('resize', function() {
        setInitialPosition();
    });
  
    $sliderHandle.on('mousedown touchstart', function(e) {
        e.preventDefault();
        $(document).on('mousemove touchmove', function(e) {
            const containerOffset = $container.offset().left;
            const containerWidth = $container.width();
            const cursorPosition = e.pageX || e.originalEvent.touches[0].pageX;
            let newLeft = cursorPosition - containerOffset;
            
            newLeft = Math.max(0, Math.min(newLeft, containerWidth));
            $sliderHandle.css('left', `${newLeft}px`);
            $imageRight.css('clip', `rect(0, ${newLeft}px, auto, 0)`);
        });

        $(document).on('mouseup touchend', function() {
            $(document).off('mousemove touchmove');
        });
    });
});

// Info Modal

$(document).ready(function() {
  $('.var_title .info').on('click', function() {
      var clickedDataId = $(this).data('id');
      $('.free_product_modal').hide();
      $('.lp_modal_wrapper').addClass('info_visible');
      $('.lp_modal').each(function() {
          $(this).hide();
          if ($(this).data('id') === clickedDataId) {
              $(this).show();
          }
      });
  });
  $('.close_modal').click(function() {
    $('.lp_modal').fadeOut();
    $(".free_product_modal").fadeIn();
    $('.lp_modal_wrapper').removeClass('info_visible');
  });
});